import './rxjs-extensions';

import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SpinnerModule } from '../spinner/spinner.module';
import { SelectModule } from '../../components/select/select.module';
import { MomentodModule } from '../../components/moment/moment.module';
import { ProgressbarModule } from '../../components/progressbar/progressbar.module';
import { StateModule } from '../../components/state/state.module';
import { GlyphModule } from '../../components/glyph/glyph.module';
import { DebounceinputModule } from '../debounceinput/debounceinput.module';

import { GridComponent } from './grid.component';
import { GridRoutingModule } from './grid.routing.module';
import {
  FilterArrayPipe,
  OrderBy
} from './grid.pipe';
import { ReportGridComponent } from './reportgrid.component';
import { InvoiceGridComponent } from './invoicegrid.component';
import { GridService } from './grid.service';
import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';
import { PaginationService } from '../../services/pagination/pagination.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    GridRoutingModule,
    StateModule,
    GlyphModule,
    SpinnerModule,
    SelectModule,
    MomentodModule,
    ProgressbarModule,
    DebounceinputModule
  ],
  exports: [
    GridComponent,
    ReportGridComponent,
    InvoiceGridComponent
  ],
  declarations: [
    GridComponent,
    ReportGridComponent,
    InvoiceGridComponent,
    FilterArrayPipe,
    OrderBy
  ],
  providers: [
    GenericdatasetService,
    GridService,
    PaginationService
  ],
})
export class GridModule { }
